import React, { FC } from 'react';
import Icon from '@minecraft.icon';
import { BasicContainer, FlexDynamic } from '@minecraft.atoms';
import { TemperatureValues } from '../enums/plans';

export const PlanLoader: FC = React.memo(() => {
  return (
    <FlexDynamic
      direction="column"
      gap="2"
      mdProps={{ direction: 'row', gap: '4' }}
      wrap="nowrap"
      justifyContent="space-around"
      className="cn_w-full cn_max-w-full"
    >
      {[TemperatureValues.vanilla, TemperatureValues.hot, TemperatureValues.cool].map((temperature) => (
        <BasicContainer
          borderColor={`${temperature}Paywall`}
          borderPlacement="all"
          borderStyle="solid"
          borderRadius="md"
          borderSize={0.1}
          className="cn_w-full cn_atom_p-2"
          key={temperature}
        >
          <Icon name="paywall-plan-skeleton" className="cn_w-full cn_max-w-full" />
        </BasicContainer>
      ))}
    </FlexDynamic>
  );
});
